<template>
  <v-app>
    <v-main v-if="isReady">
      <transition name="fade-transform" mode="out-in">
        <router-view />
      </transition>
    </v-main>
  </v-app>
</template>

<script>
/*
Actions:
  Use setTimeout:
    because in 404 the discovey page intent load and show errors
*/
export default {
  name: "Default",
  data: () => ({
    isReady: false,
  }),
  mounted() {
    setTimeout(() => {
      this.isReady = true;
    }, 10);
  },
};
</script>
